import { useSelector } from "../../hooks";
import { ModalBonus } from "./ModalBonus/ModalBonus";
import { ModalNotify } from "./ModalNotify/ModalNotify";

export const ModalsCont = () => {
    const { items: notifications } = useSelector(store => store.notifications);
    const { bonuses } = useSelector(store => store.user.info);

    return (
        <>
            {
                bonuses.length > 0
                    ? <ModalBonus />
                    : notifications.length > 0 && <ModalNotify />
            }
        </>
    );
}